export default {
	title: '场景',
	subtitle: '列出您将评估的所有可能场景',
	no_description: '无场景描述',

	context_worse: '负面',
	context_best: '正面',

	tabs: {
		list: '列表',
		details: '详情',
		visualization: '可视化',
		alt_title: '综合'
	}
};
